/**
 * News & Resources Component
 * 소식 & 자료 섹션 Swiper 초기화
 */
export class NewsResources {
    constructor() {
        this.slider = null;
        this.init();
    }

    init() {
        const sliderEl = document.querySelector('.no-news-resources__slider');
        if (!sliderEl) return;

        // Swiper가 로드되었는지 확인
        if (typeof Swiper === "undefined") {
            console.warn("NewsResources: Swiper library not found");
            return;
        }

        // 기존 스와이퍼가 있으면 제거
        if (this.slider) {
            this.slider.destroy(true, true);
            this.slider = null;
        }

        // Swiper 초기화
        this.slider = new Swiper(sliderEl, {
            slidesPerView: 3,
            spaceBetween: 32,
            loop: false,
            watchOverflow: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
            on: {
                init: function () {
                    this.update();
                    this.updateSlides();
                },
            },
        });
    }

    destroy() {
        if (this.slider) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}
